import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SurveyBaseComponent } from '../survey-base/survey-base.component';

@Component({
  selector: 'app-survey-pre-question-dialog',
  templateUrl: './survey-pre-question-dialog.component.html',
  styleUrls: ['./survey-pre-question-dialog.component.scss'],
  standalone: false
})
export class SurveyPreQuestionDialogComponent extends SurveyBaseComponent implements OnInit, OnDestroy {
  @Input() dialogObj: any;
  @Input() surveyData: any

  defaultImagePath = "assets/images/fullface.jpg";
  imagePath: string;
  firstName: string;
  showMaskImage: boolean;

  ngOnInit(): void {
    this.showMaskImage = this.dialogObj.ShowMaskImage ?? false

    if("ImagePath" in this.dialogObj) {
      this.imagePath = this.dialogObj.ImagePath;
    }
    else if (this.surveyData.maskUrl == null) {
      this.imagePath = this.defaultImagePath;
    }
    else {
      this.imagePath = this.surveyData.maskUrl;
    }
    this.firstName = this.surveyData.firstName;
  }
}
